
import { defineComponent, ref, watchEffect } from 'vue';
import TableContentLoader from './TableContentLoader.vue';
import { useStore } from 'vuex';
import CustomerDetailTableContentLoader from '../../modules/customer/customers/components/partials/CustomerDetailTableContentLoader.vue';

export default defineComponent({
    props: {
        columns: { type: Object, required: true },
        rows: { type: Array, required: true },
        show_empty: { type: Boolean, default: false },
        pagination: {
            type: Object,
            default() {
                return {};
            }
        },
        padding: { type: Number },
        textAlignment: { type: String, default: '' },
        module: { type: String, default: '' },
        width: { type: String, default: '' },
        loading: { type: Boolean, default: false },
        sorting: { type: Boolean, default: false },
        fluid: { type: Boolean, default: false }
    },
    components: { TableContentLoader, CustomerDetailTableContentLoader },
    setup(props: Record<any, any>) {
        const type = ref(true);
        const state = ref(false);
        const store = useStore();

        const changeType = (types: boolean) => {
            type.value = !types;
            state.value = true;
        };

        // Fluid tables live in narrow cards, where fixed column minimums force the last columns out of view
        const minWidthClass = (column: Record<any, any>) => {
            if (props.fluid) return '';
            return column?.width ? 'min-w-100px' : 'min-w-140px';
        };

        watchEffect(() => {
            const searchData = store.getters.getSearchData;
            if (Object.entries(searchData).length == 0) {
                state.value = false;
            }
        });

        return {
            type,
            changeType,
            state,
            minWidthClass
        };
    }
});
